<template>
  <div class="notfound">
    <h1>Not Found</h1>
    <p>再仔細想想看吧，你可以的！</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  props: {},
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>
.notfound {
  width: 100%;
  height: 100vh;
  background-color: #222;
  color: #eee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
